import React, { useState, useEffect } from 'react';
import {
    useNotify,
    useRefresh
} from 'react-admin';
import { makeStyles } from "@material-ui/core/styles";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import PhoneIcon from '@mui/icons-material/Phone';
import PersonIcon from '@mui/icons-material/Person';
import FingerprintIcon from '@mui/icons-material/Fingerprint';
import Chip from '@mui/material/Chip';

const useStyles = makeStyles({
    headerCell: {
        backgroundColor: '#def',
        fontWeight: 'bold',
        textAlign: 'center',
        padding: '10px',
    },
    eventListContainer: {
        marginTop: '20px',
        padding: '10px',
        backgroundColor: '#f9f9f9',
        border: '1px solid #ccc',
        borderRadius: '4px',
    },
    eventGroup: {
        marginBottom: '10px',
    },
    eventGroupTitle: {
        fontWeight: 'bold',
        fontSize: '16px',
        marginBottom: '5px',
    },
    eventItem: {
        padding: '5px 0',
        borderBottom: '1px solid #eee',
    },
    genderLabel: {
        marginLeft: 'auto', // Push to the right
        backgroundColor: '#e0f7fa',
        color: '#00796b',
        fontWeight: 'bold',
        borderRadius: '15px',
        padding: '2px 3px',
    }
});

const AppointmentList = (props) => {
    const {REACT_APP_API_ENDPOINT} = process.env;
    const classes = useStyles();
    const notify = useNotify();
    const refresh = useRefresh();
    const [selectedDate, setSelectedDate] = useState(null);
    const [events, setEvents] = useState([]); // Store all events for the current month
    const [selectedDateEvents, setSelectedDateEvents] = useState([]); // Store events for the selected day
    const [currentDateRange, setCurrentDateRange] = useState({ start: null, end: null });

    // Fetch events based on the current month (or range)
    const fetchEvents = async (start, end) => {
        try {
            const response = await fetch(REACT_APP_API_ENDPOINT+`/appointment/events?start=${start}&end=${end}`);
            const data = await response.json();
            setEvents(data.result); // Assuming the API returns the list of events
        } catch (error) {
            notify('Failed to fetch events', 'error');
        }
    };

    // Handle when a date is clicked in the calendar
    const handleDateClick = async (info) => {
        const clickedDate = info.event.extendedProps.date; // This will give us the date in "YYYY-MM-DD" format
        setSelectedDate(clickedDate);
        const filteredEvents = await fetch(REACT_APP_API_ENDPOINT+`/appointment/events/day?date=${clickedDate}`);
        const events = await filteredEvents.json();
        setSelectedDateEvents(events.result);
    };

    // Handle when the visible date range changes (e.g., when switching months)
    const handleDatesSet = (dateInfo) => {
        const { start, end } = dateInfo;
        const formattedStart = start.toISOString().split('T')[0];
        const formattedEnd = end.toISOString().split('T')[0];
        setCurrentDateRange({ start: formattedStart, end: formattedEnd });
        fetchEvents(formattedStart, formattedEnd);
    };

    // Group events by appointment time and sort by slot number
    const groupEventsByTime = (events) => {
        const grouped = events.reduce((acc, event) => {
            const time = event.appointment_time;
            if (!acc[time]) {
                acc[time] = [];
            }
            acc[time].push(event);
            return acc;
        }, {});

        // Sort each group by slot number
        Object.keys(grouped).forEach(time => {
            grouped[time].sort((a, b) => a.slot_number - b.slot_number);
        });

        return grouped;
    };

    return (
        <div>
            <div>
                <h2>Appointments</h2>
            </div>
            <Card>
                <CardContent>
                    <div style={{ display: 'flex' }}>
                        <div style={{ flex: 1,maxWidth:'50%' }}>
                                <FullCalendar
                                    plugins={[dayGridPlugin]}
                                    initialView="dayGridMonth"
                                    events={events}
                                    headerToolbar={{
                                        left: 'prev,next',
                                        center: 'title',
                                        right: 'today',
                                    }}
                                    eventClick={handleDateClick}
                                    datesSet={handleDatesSet} // Refetch events when month is changed
                                />

                        </div>

                        {(selectedDate)&& (
                            <div style={{flex: 1, marginLeft: '20px'}}>
                                <div>
                                    <Card>
                                        <CardContent>
                                            <Typography gutterBottom variant="h5" component="div">
                                                Appointments for {selectedDate}
                                            </Typography>
                                            <br/>
                                            {selectedDateEvents.length > 0 ? (
                                                Object.entries(groupEventsByTime(selectedDateEvents)).map(([time, appointments], index) => (
                                                    <div key={index} className={classes.eventGroup}>
                                                        <List sx={{
                                                            padding: '10px',
                                                            boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.3)'
                                                        }}>
                                                            <h4 style={{margin: '10px', marginLeft: '20px'}}>Appointment
                                                                Time: {time}</h4>
                                                            {appointments.map((event, idx) => (
                                                                <>
                                                                    <Divider component="li"/>
                                                                    <ListItem key={idx} alignItems="flex-start">
                                                                        <ListItemAvatar>
                                                                            <Avatar sx={{bgcolor: 'primary.main'}}>
                                                                                {event.slot_number}
                                                                            </Avatar>
                                                                        </ListItemAvatar>
                                                                        <ListItemText
                                                                            primary={event.donor.name}
                                                                            secondary={
                                                                                <React.Fragment>

                                                                                    <PhoneIcon sx={{
                                                                                        verticalAlign: 'middle',
                                                                                        'fontSize': '15px',
                                                                                        marginRight: '5px'
                                                                                    }}/>
                                                                                    Phone: {event.donor.don_ph}
                                                                                    <br/>
                                                                                    <FingerprintIcon sx={{
                                                                                        verticalAlign: 'middle',
                                                                                        'fontSize': '15px',
                                                                                        marginRight: '5px'
                                                                                    }}/>
                                                                                    SSN: {event.donor.ssn}
                                                                                </React.Fragment>
                                                                            }
                                                                        />
                                                                        <Chip
                                                                            label={event.donor.gender}
                                                                            style={{
                                                                                marginLeft: 'auto',
                                                                                backgroundColor: '#e0f7fa',
                                                                                color: '#00796b',
                                                                                fontSize: '12px',
                                                                                borderRadius: '15px',
                                                                                padding: ' 0px 5px',
                                                                                marginRight: '10px'
                                                                            }}
                                                                        />
                                                                        {(event.status=="booked")&&(

                                                                            <Chip
                                                                                label="Booked"
                                                                                style={{
                                                                                    marginLeft: 'auto',
                                                                                    backgroundColor: '#c9e499',
                                                                                    color: '#00796b',
                                                                                    fontSize: '12px',
                                                                                    borderRadius: '15px',
                                                                                    padding: ' 0px 5px',
                                                                                }}
                                                                            />
                                                                        )}
                                                                        {(event.status=="canceled")&&(

                                                                            <Chip
                                                                                label="Canceled"
                                                                                style={{
                                                                                    marginLeft: 'auto',
                                                                                    backgroundColor: '#e4a299',
                                                                                    color: '#cd1515',
                                                                                    fontSize: '12px',
                                                                                    borderRadius: '15px',
                                                                                    padding: ' 0px 5px',
                                                                                }}
                                                                            />
                                                                        )}

                                                                    </ListItem>
                                                                </>
                                                            ))}
                                                        </List>
                                                    </div>
                                                ))
                                            ) : (
                                                <p>No events for this day</p>
                                            )}
                                        </CardContent>
                                    </Card>
                                </div>
                            </div>
                        )}

                    </div>
                </CardContent>
            </Card>
        </div>
    );
};

export default AppointmentList;
